import { useLocation } from 'react-router';

const PLAIN_PAGE_PATH_SUFFIX = 'plain';

export const isPathToPlainPage = (pathname: string) =>
  pathname.endsWith(`/${PLAIN_PAGE_PATH_SUFFIX}`) || pathname.endsWith(`/${PLAIN_PAGE_PATH_SUFFIX}/`);

export const useIsPlainPage = () => {
  const { pathname } = useLocation();

  return isPathToPlainPage(pathname);
};

export const convertAbsoluteUrlToPlain = (sourceUrl: string) => {
  const parsedUrl = new URL(sourceUrl);
  if (isPathToPlainPage(parsedUrl.pathname)) {
    return sourceUrl;
  }

  parsedUrl.pathname += parsedUrl.pathname.endsWith('/') ? '' : '/';
  parsedUrl.pathname += `${PLAIN_PAGE_PATH_SUFFIX}/`;
  return parsedUrl.toString();
};

export const convertRelativeUrlToPlain = (sourceUrl: string) => {
  const parsedUrl = new URL(sourceUrl, window.location.origin);
  if (isPathToPlainPage(parsedUrl.pathname)) {
    return sourceUrl;
  }

  parsedUrl.pathname += parsedUrl.pathname.endsWith('/') ? '' : '/';
  parsedUrl.pathname += `${PLAIN_PAGE_PATH_SUFFIX}/`;
  return parsedUrl.pathname;
};

export const usePlainPageRoute = (sourceUrl: string) => {
  const isPlainPage = useIsPlainPage();
  return isPlainPage ? convertRelativeUrlToPlain(sourceUrl) : sourceUrl;
};

export const shouldRedirectToPlainPage = (referrer: string, currentPathname: string) => {
  const referrerPathname = referrer ? new URL(referrer).pathname : '';
  return isPathToPlainPage(referrerPathname) && !isPathToPlainPage(currentPathname);
};
